import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import tableCanvasInteractableTabs from './tableCanvasInteractableTabs';

export default {
  title: 'Interactable Tabs',
  attributeName: 'interactableTabs',
  helpText: 'Configure the interactable tabs that will be displayed in the Canvas section of the Main Hub.',
  fields: [
    {
      attributeName: 'interactablePanels',
      label: 'Tabs',
      type: FormInputTypes.TABLE,
      helpText: '',
      configFile: tableCanvasInteractableTabs,
    },
  ],
};